module.exports = __webpack_public_path__ + "img/dcmm_3.9959991a.png";